import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import fireBallIndicator from '../../assets/apng/fireball-indicator.png';

export type Part = 1 | 2 | 3 | 4 | 5;

export type GamePartProps = HTMLAttributes<HTMLDivElement> & {
    gameParts: Part;
    currentPart: Part;
    fireBall?: number;
};

const GamePartContainer = styled.div`
    display: flex;
`;

export const GamePartDot = styled.div<{ isActive: boolean }>`
    position: relative;
    box-sizing: border-box;
    width: 0.813rem;
    height: 0.813rem;
    border-radius: 50%;
    margin-right: 0.25rem;

    ${({ isActive, theme: { gamePart } }) => `
        ${
            isActive
                ? `
                border: none;
                background-color: ${gamePart.background.active};
                box-shadow: inset 0 0.063rem 0 0  ${gamePart.boxShadow.first.active};
            `
                : `
                border: solid 0.031rem ${gamePart.border};
                background-color:  ${gamePart.background.inactive};
                box-shadow: 0 0.063rem 0 0 ${gamePart.boxShadow.first.inactive},
                inset 0 0.125rem 0.188rem 0 ${gamePart.boxShadow.second};
            `
        }
    `};
`;

export const FireBallIndicatorImage = styled.img`
    box-sizing: border-box;
    width: 0.813rem;
    height: 0.813rem;
    margin-right: 0.25rem;
    margin-left: 3px;
    transform: scale(1.75);
    object-fit: contain;
    pointer-events: none;
    z-index: 1;
`;

export const GamePart: FC<GamePartProps> = ({
    gameParts,
    currentPart,
    fireBall,
    ...props
}) => {
    const GAME_PARTS = Array.from({ length: gameParts }).map((_v, i) => i + 1);
    const showFireBallIndicator = !!fireBall && fireBall > 0;

    return (
        <GamePartContainer {...props}>
            {GAME_PARTS.map((part) => {
                const isActive = currentPart >= part;
                const isLastPart = part === gameParts;
                const showIndicator = showFireBallIndicator && isLastPart;

                return showIndicator ? (
                    <FireBallIndicatorImage
                        key={part}
                        src={fireBallIndicator}
                        alt=""
                    />
                ) : (
                    <GamePartDot key={part} isActive={isActive} />
                );
            })}
        </GamePartContainer>
    );
};
